import {
  APP_DEEP_LINKS,
  matchDeepLinkId,
  shouldWarnDestination,
} from './appDeepLinks';

type Props = {
  label?: string;
  value: string;
  onChange: (next: string) => void;
  className?: string;
  inputClassName?: string;
};

export function DestinationField({
  label = 'Destino',
  value,
  onChange,
  className,
  inputClassName = 'mt-1 w-full rounded-lg border border-border bg-background px-3 py-2 font-mono text-xs',
}: Props) {
  const selectedId = matchDeepLinkId(value);
  const warn = shouldWarnDestination(value);

  return (
    <div className={className}>
      <label className="block text-sm">
        {label}
        <select
          className="mt-1 w-full rounded-lg border border-border bg-background px-3 py-2 text-sm"
          value={selectedId}
          onChange={(e) => {
            const id = e.target.value;
            if (!id) return;
            const link = APP_DEEP_LINKS.find((d) => d.id === id);
            if (link) onChange(link.path);
          }}
        >
          <option value="">— Elegir pantalla —</option>
          {APP_DEEP_LINKS.map((d) => (
            <option key={d.id} value={d.id}>
              {d.label} ({d.path})
            </option>
          ))}
        </select>
      </label>
      <label className="mt-2 block text-sm text-muted-foreground">
        URL (ruta de app o https)
        <input
          className={inputClassName}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="/add-catch o https://…"
        />
      </label>
      {warn && (
        <p className="mt-1 text-xs text-amber-700 dark:text-amber-400">
          Esta URL no está en la lista oficial de la app ni es un https externo. Revisa el destino
          antes de activar.
        </p>
      )}
    </div>
  );
}
